import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";
import { getUserDetails } from "../utils/userDetailsUtils";

const downloadReportApi = async ({ tcrid, tcid, format, principleLevel, testStepId }) => {
  const user = getUserDetails();
  const base = `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=downloadUIDesignReport&companyid=${user.companyid}&format=${format}&principleLevel=${principleLevel}`;

  let url =
    principleLevel === "Test_step"
      ? `${base}&testCaseId=${tcid}`
      : `${base}&testCaseResultsId=${tcrid}`;

  if (principleLevel === "Test_step" && testStepId) {
    url += `&testStepId=${testStepId}`;
  }

  const response = await axios.get(url, { responseType: "blob" });
  return response;
};

const useDownloadReport = () => {
  return useMutation({
    mutationFn: downloadReportApi,
  });
};

export default useDownloadReport;